
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packages/elle",
      function () {
        return require("private-next-pages/packages/elle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packages/elle"])
      });
    }
  